// @module C3.ShoppingExtensions.PLP
define('C3.ShoppingExtensions.VisualSystemPage.ResourceMacro.View'
,	[
	'visual_systempage_resources_macro_view.tpl'
	
		, 'AjaxRequestsKiller'
		,   'Utils'
    ]
, function (
	visual_systempage_resources_macro_view_tpl
	
	,   AjaxRequestsKiller
	,   Utils
)
{
    'use strict';

	// @class C3.ShoppingExtensions.PLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: visual_systempage_resources_macro_view_tpl

	,	initialize: function (options) {
			//console.log(options)
		    this.resources = options.resources;
			this.application = options.application;
			this.model = options.model;
			//this._render();
		}

	,	events: {
		}

	/*,  render: function(){
			this._render();
	    }*/


	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return C3.ShoppingExtensions.PLP.View.Context
	,	getContext: function getContext()
		{
			//console.log(this.resources)
			return {
				/*text : this.model.get('text'),
				thumbnail : this.model.get('thumbnail'),
				internalid : this.model.get('internalid'),
				value : this.model.get('value'),*/
				resources : this.resources,
				hasResources : this.resources.length > 0,
				isPhoneDevice : Utils.isPhoneDevice()
			};
		}
	});
});
